module.exports = __webpack_public_path__ + "img/xinwen12.d44b81da.jpg";